import * as React from 'react';
export const darkModeSvg = React.forwardRef(function darkModeSvgInner(
  props,
  ref,
) {
  return /*#__PURE__*/ React.createElement(
    'svg',
    {
      ...props,
      ref: ref,
    },
    /*#__PURE__*/ React.createElement('path', {
      d: 'm7.068 2 .552.507a.75.75 0 0 0-.672-1.247l.12.74ZM14 8.932l.74.12a.75.75 0 0 0-1.247-.672l.507.552ZM7.068 2l-.552-.507a5.639 5.639 0 0 0-1.491 3.826h1.5A4.14 4.14 0 0 1 7.62 2.507L7.068 2ZM5.775 5.319h-.75a5.657 5.657 0 0 0 5.657 5.657v-1.5a4.157 4.157 0 0 1-4.157-4.157h-.75Zm4.907 4.907v.75c1.476 0 2.82-.567 3.825-1.492L14 8.932l-.507-.552a4.138 4.138 0 0 1-2.811 1.096v.75ZM14 8.932l-.74-.12a5.29 5.29 0 0 1-5.22 4.438v1.5a6.79 6.79 0 0 0 6.7-5.698l-.74-.12ZM8.04 14v-.75a5.29 5.29 0 0 1-5.29-5.29h-1.5a6.79 6.79 0 0 0 6.79 6.79V14ZM2 7.96h.75a5.29 5.29 0 0 1 4.438-5.22L7.068 2l-.12-.74a6.79 6.79 0 0 0-5.698 6.7H2Z',
    }),
  );
});
darkModeSvg.defaultProps = {
  xmlns: 'http://www.w3.org/2000/svg',
  width: '16',
  height: '16',
  viewBox: '0 0 16 16',
  fill: 'none',
};
export var darkMode = {
  category: 'icon',
  colorable: true,
  name: 'darkMode',
  svg: darkModeSvg,
};
